import account from './account'
import invoice from './invoice'
import webhook from './webhook'
import taxInvoiceYapay from './taxInvoiceYapay'
import taxInvoiceNfeIo from './taxInvoiceNfeIo'
import profile from './profile'

export default {
  account,
  invoice,
  webhook,
  taxInvoiceYapay,
  taxInvoiceNfeIo,
  profile,
}
